import {
  corridorRelayQuery,
  useClearCorridorRelayMutation,
} from "@common/api/corridor-relay"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { getErrorMessage } from "@common/utils"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/integrations/erp/_list/relay/remove",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "erp_config:update",
      "/settings/workspace/general",
    ),
  loader: async ({ context: { queryClient } }) => {
    const { relay } = await queryClient.ensureQueryData(corridorRelayQuery())
    if (!relay) {
      throw redirect({ to: "/settings/integrations/erp", replace: true })
    }
  },
  component: RemoveRelayDialog,
})

function RemoveRelayDialog(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const clearMutation = useClearCorridorRelayMutation()

  const close = () => navigate({ to: "/settings/integrations/erp" })

  const confirm = () =>
    clearMutation.mutate(
      {},
      {
        onSuccess: () => {
          showToast("Removed", "Corridor desktop relay removed.", "success")
          close()
        },
        onError: (error) => showToast("Error", getErrorMessage(error), "error"),
      },
    )

  return (
    <ConfirmDialog
      title="Remove the Corridor desktop relay?"
      description="Quotes can't be sent to Corridor until a relay is set up again. Queued sends will fail."
      action="Remove"
      pendingAction="Removing…"
      pending={clearMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
